import React from 'react'
import { StatusBadge } from '@/components/status-badges'

export default function Index() {
  return (
    <div className="container mx-auto py-8">
      <h1 className="text-3xl font-bold mb-6">Style Guide</h1>
      <div className="space-y-8 p-6">
        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Deal Status Badges</h2>
          <div className="grid grid-cols-1 gap-8">
            <div className="space-y-2">
              <div className="flex flex-wrap gap-2">
                <StatusBadge status={{ type: 'deal', status: 'draft' }} />
                <StatusBadge status={{ type: 'deal', status: 'active' }} />
                <StatusBadge status={{ type: 'deal', status: 'expiring' }} />
                <StatusBadge status={{ type: 'deal', status: 'expired' }} />
                <StatusBadge status={{ type: 'deal', status: 'archived' }} />
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Expiry Policy Badges</h2>
          <div className="grid grid-cols-1 gap-8">
            <div className="space-y-2">
              <div className="flex flex-wrap gap-2">
                <StatusBadge status={{ type: 'expiryPolicy', status: 'extend' }} />
                <StatusBadge status={{ type: 'expiryPolicy', status: 'expire' }} />
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Update Request Badges</h2>
          <div className="grid grid-cols-1 gap-8">
            <div className="space-y-2">
              <div className="flex flex-wrap gap-2">
                <StatusBadge status={{ type: 'updateRequest', status: 'activate' }} />
                <StatusBadge status={{ type: 'updateRequest', status: 'extend' }} />
                <StatusBadge status={{ type: 'updateRequest', status: 'expire' }} />
                <StatusBadge status={{ type: 'updateRequest', status: 'archive' }} />
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <h2 className="text-xl font-semibold">Term Status Badges</h2>
          <div className="grid grid-cols-1 gap-8">
            <div className="space-y-2">
              <div className="flex flex-wrap gap-2">
                <StatusBadge status={{ type: 'term', status: 'not_taken' }} />
                <StatusBadge status={{ type: 'term', status: 'taken' }} />
                <StatusBadge status={{ type: 'term', status: 'active' }} />
                <StatusBadge status={{ type: 'term', status: 'upcoming' }} />
                <StatusBadge status={{ type: 'term', status: 'expired' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
